import ProductReviewGallerySlider, { ProductReviewGallerySliderProps } from './ProductReviewGallerySlider'

export default ProductReviewGallerySlider

export { ProductReviewGallerySliderProps, ProductReviewGallerySlider }
